import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_SelectField = _resolveComponent("SelectField")!
  const _component_v_date_input = _resolveComponent("v-date-input")!
  const _component_NumberField = _resolveComponent("NumberField")!
  const _component_v_radio = _resolveComponent("v-radio")!
  const _component_v_radio_group = _resolveComponent("v-radio-group")!
  const _component_TextAreaField = _resolveComponent("TextAreaField")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    loading: _ctx.loading,
    disabled: _ctx.loading
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { md: "12" }, {
                default: _withCtx(() => _cache[6] || (_cache[6] = [
                  _createTextVNode(" Register Leave ")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_form, {
            ref: "frmLeave",
            modelValue: _ctx.valid,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.valid) = $event)),
            "lazy-validation": "",
            class: "form-inputs"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "12",
                    sm: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_SelectField, {
                        id: "tm_register_leave_commitment",
                        readonly: _ctx.model.isLocked,
                        disabled: _ctx.model.isLocked,
                        rules: [_ctx.rules.required],
                        label: "Commitment",
                        placeholder: "Commitment",
                        items: _ctx.filteredCommitments,
                        "item-title": "Name",
                        "item-value": "id",
                        modelValue: _ctx.model.CommitmentId,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.CommitmentId) = $event)),
                        outlined: ""
                      }, null, 8, ["readonly", "disabled", "rules", "items", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    md: "6"
                  }, {
                    default: _withCtx(() => [
                      _cache[7] || (_cache[7] = _createElementVNode("label", { class: "input-label" }, " Date ", -1)),
                      _createVNode(_component_v_date_input, {
                        id: "tm_register_leave_date",
                        readonly: _ctx.model.isLocked,
                        disabled: _ctx.model.isLocked,
                        min: _ctx.minDate,
                        "first-day-of-week": "1",
                        rules: [_ctx.rules.required],
                        modelValue: _ctx.model.Date,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.Date) = $event)),
                        "hide-actions": "",
                        placeholder: "Date",
                        "prepend-icon": ""
                      }, null, 8, ["readonly", "disabled", "min", "rules", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    md: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_NumberField, {
                        id: "tm_register_leave_hours",
                        readonly: _ctx.model.isLocked,
                        disabled: _ctx.model.isLocked,
                        rules: [_ctx.rules.required, _ctx.rules.float, _ctx.rules.maximum, _ctx.rules.minimum],
                        modelValue: _ctx.selectedHours,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedHours) = $event)),
                        min: "0",
                        max: "10",
                        step: "0.5",
                        label: "Hours",
                        placeholder: "Hours",
                        outlined: ""
                      }, null, 8, ["readonly", "disabled", "rules", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_radio_group, {
                        id: "tm_register_leave_radio_button",
                        readonly: _ctx.model.isLocked,
                        disabled: _ctx.model.isLocked,
                        modelValue: _ctx.model.Type,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.Type) = $event)),
                        row: ""
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leaveTypes, (item) => {
                            return (_openBlock(), _createBlock(_component_v_radio, {
                              key: 'type_' + item,
                              label: item,
                              value: item
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["readonly", "disabled", "modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "12"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_TextAreaField, {
                        id: "tm_register_leave_description",
                        readonly: _ctx.model.isLocked,
                        disabled: _ctx.model.isLocked,
                        modelValue: _ctx.model.Description,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.Description) = $event)),
                        outlined: "",
                        height: "120",
                        placeholder: "Description",
                        label: "Description"
                      }, null, 8, ["readonly", "disabled", "modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_card_actions, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { md: "12" }, {
            default: _withCtx(() => [
              (!_ctx.model.isLocked)
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    id: "tm_register_leave_save",
                    color: "secondary",
                    onClick: _ctx.save
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, null, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createTextVNode("mdi-check")
                        ])),
                        _: 1
                      }),
                      _cache[9] || (_cache[9] = _createTextVNode(" Save"))
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_v_btn, {
                id: "tm_register_leave_cancel",
                text: "",
                color: "primary",
                class: "ml-2",
                onClick: _ctx.cancel
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createTextVNode("Cancel")
                ])),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["loading", "disabled"]))
}